import axios from "axios";

import {
  fullAPIURL,
  getHttpProtocol as scheme,
  getTaskServiceUrl as taskServiceUrl,
} from "../utils/requests";
import { refreshAccessTokenInterceptor } from "../utils/refreshTokens";
import {
  requestAccessTokenInterceptor,
  responseStatusInterceptor,
} from "../utils/axios.utils";
import { TaskListStatus } from "../pages/GetStarted/GetStartedLanding/SetupGuide/OnboardingTaskListCard";
import { CelebrationType } from "./metricsApi";

const taskAxios = axios.create({
  baseURL: `${fullAPIURL}/v2/task`,
  headers: { "Content-Type": "application/json" },
  validateStatus: null,
});

taskAxios.interceptors.request.use(requestAccessTokenInterceptor);
taskAxios.interceptors.request.use(refreshAccessTokenInterceptor);
taskAxios.interceptors.response.use(responseStatusInterceptor);

export type TaskLink = {
  id: number;
  text: string;
  url: string;
  taskId: number;
};

export type Task = {
  id: number;
  uuid: string;
  links: TaskLink[];
  title: string;
  taskId: number;
  createdAt: string;
  updatedAt: string;
  isComplete: number;
  completedAt: string;
  description: string;
};

export type TaskList = {
  id: number;
  uuid: string;
  taskListId: number;
  title: string;
  userId: number;
  userUuid: string;
  clientId: number;
  clientUuid: string;
  isComplete: number;
  completedAt: string | null;
  createdAt: string;
  updatedAt: string;
  tasks: Task[];
  status?: TaskListStatus; // derived on the frontend, not persisted in the backend
};

export type GetOnboardingTaskListsResponse = TaskList[];
export async function getOnboardingTaskLists() {
  const url = `/onboarding`
  const response = await taskAxios.get<GetOnboardingTaskListsResponse>(url);
  return response.data;
}

export async function updateTask({ taskUuid, markAsComplete }: { taskUuid: string, markAsComplete: boolean }): Promise<void> {
  const url = `/update/${taskUuid}`;
  await taskAxios.put(url, { markAsComplete });
}

export type OutReachProps = {
  message: {
    content: string;
  };
  event: {
    type: CelebrationType;
    date: string;
  };
  recipient: {
    uuid: string;
    name: string;
    email?: string;
    phone: string;
  };
}

export async function sendOutreachSmsTask({ message, event, recipient }: OutReachProps) {
  return await taskAxios.post('/outreach/sms', { message, event, recipient });
}
